import React, { useState } from 'react';
import { IonReactRouter } from '@ionic/react-router';
import { IonModal } from '@ionic/react';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Capacitor } from '@capacitor/core';
import { isPlatform } from '@ionic/react';

// Routes
import { SwitchRoute } from './SwitchRoute';

// Components
import { Splash } from '../components';

// Helpers
import { extractSplashInfo, isWeb, isMobileWeb, isWebView } from '../helpers';

export const AppRouter = () => {
    const isBrowser = isWeb() || isMobileWeb();
    const isWebview = isWebView();
    const [splash, setSplash] = useState(true);
    const splashActivated = extractSplashInfo(isBrowser);
    // Si aplica splash
    if (splashActivated.ACTIVE) {

        setTimeout(() => {

            setSplash(false);

        }, splashActivated.TIME_HIDE);

        if (splash && !isWebview) {

            SplashScreen.hide();
            return <IonModal cssClass="animate__animated animate__fadeIn slow" isOpen={splash}>
                <Splash />
            </IonModal>
        }
    }

    return (

        <>
            <IonReactRouter>
                <SwitchRoute />
            </IonReactRouter>
        </>
    )
}
